import './PetInfoDropDownItem.scss';
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as PetCat } from '@/assets/img/pet-cat-default-icon.svg';
import { ReactComponent as PetDog } from '@/assets/img/pet-dog-default-icon.svg';
import { Pets } from '@/features/customers';
type PetInfoDropDownItemProps = {
  data?: Pets;
};
export const PetInfoDropDownItem = ({ data }: PetInfoDropDownItemProps) => {
  return (
    <div className={`pet-info-dropdown-item`}>
      <div className="pets-image">
        {data && data.petsImageUrl ? (
          <img src={data.petsImageUrl} />
        ) : data?.petType?.toLowerCase() === 'cat' ? (
          <PetCat />
        ) : (
          <PetDog />
        )}
      </div>
      <div className="pet-info-dropdown-details">
        <div className="name" title={data?.name}>
          {data?.name}
        </div>
        <div className="breed" title={data?.breed}>
          {data?.breed}
        </div>
      </div>
    </div>
  );
};
